import React, {useState} from 'react';
import Modal from "react-modal";
import {makeApiCall} from "../../../Api/makeApiCall";
import PropTypes from "prop-types";

export const ShowReportPartial = ({path, runId, fileType, rowCount}) => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [fileData, setFileData] = useState(undefined);

    async function getFilePartial(url) {
        const apiEndpointUrl = `${process.env.REACT_APP_EDP_API_BASE_URL}/getGcsFilePartial/?is_json=true&path=${encodeURIComponent(url)}&start=0&end=50000`;
        makeApiCall(apiEndpointUrl).then(response => {
            if (response.apiError)
                setFileData("File is too large to display");
            else {
                setFileData(JSON.stringify(response, null, 2))
            }
        });
    }

    const lastSlash = path.lastIndexOf('/');
    const fileName = path.substring(lastSlash + 1);
    const url = fileType ? `gs://${process.env.REACT_APP_GCS_TMP_BASE_URL}${runId}/report/p_data${'=' + fileType.getPartition()}/normalized_record_report/${fileName + '.json'}` : '';

    return <>
        {rowCount > 0 ? <a className={'issues-link'} onClick={async () => {
            if (rowCount > 0) {
                setIsModalOpen(true);
                await getFilePartial(url)
            }
        }}>Issues:</a> : <div>Issues:</div>}
        <Modal
            isOpen={isModalOpen}
            className="Modal show-file-partial-modal"
            overlayClassName="Overlay"
            ariaHideApp={false}
            testId={"show-report-partial-modal"}
        >
            <div className={'modal-x-close'}>
                <button className={"modal-x-close-button"} type="button" name="close"
                        onClick={() => setIsModalOpen(false)}>
                    X
                </button>
            </div>
            <h2>First 50000 characters of {url}</h2>
            <div className={'file-partial-content'}>{fileData && fileData}</div>
        </Modal>
    </>
}

ShowReportPartial.propTypes = {
    path: PropTypes.string,
    runId: PropTypes.string,
    fileType: PropTypes.object,
    rowCount: PropTypes.number
}
